import React from 'react';

const viLoopVideo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 16"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path d="M8.40055 14.6667V1.33337M5.06722 14.6667V11.3334M5.06722 4.66671V1.33337M11.7339 14.6667V11.3334M11.7339 4.66671V1.33337M1.73389 4.66671H15.0672M1.73389 11.3334H15.0672M15.0672 11.4667V4.53337C15.0672 3.41327 15.0672 2.85322 14.8492 2.42539C14.6575 2.04907 14.3515 1.74311 13.9752 1.55136C13.5474 1.33337 12.9873 1.33337 11.8672 1.33337L4.93389 1.33337C3.81378 1.33337 3.25373 1.33337 2.82591 1.55136C2.44958 1.74311 2.14362 2.04907 1.95187 2.42539C1.73389 2.85322 1.73389 3.41327 1.73389 4.53337L1.73389 11.4667C1.73389 12.5868 1.73389 13.1469 1.95187 13.5747C2.14362 13.951 2.44958 14.257 2.82591 14.4487C3.25373 14.6667 3.81378 14.6667 4.93389 14.6667H11.8672C12.9873 14.6667 13.5474 14.6667 13.9752 14.4487C14.3515 14.257 14.6575 13.951 14.8492 13.5747C15.0672 13.1469 15.0672 12.5868 15.0672 11.4667Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);

export default viLoopVideo;
